import type { FormField, VisibilityRule } from './types'

export function isFieldVisible(rule: VisibilityRule | undefined, values: Record<string, unknown>): boolean {
  if (!rule) return true
  const current = String(values[rule.fieldId] ?? '').toLowerCase()
  const expected = rule.value.toLowerCase()
  if (rule.operator === 'equals') return current === expected
  if (rule.operator === 'not_equals') return current !== expected
  return current.includes(expected)
}

export function validateForm(fields: FormField[], values: Record<string, unknown>): Record<string, string> {
  return fields.reduce<Record<string, string>>((errors, field) => {
    if (!isFieldVisible(field.visibility, values)) return errors
    const value = values[field.id]
    if (field.required && (value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0))) {
      errors[field.id] = `${field.label} is required`
    }
    if (field.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value))) errors[field.id] = 'Enter a valid email address'
    if (field.type === 'url' && value) {
      try { new URL(String(value)) } catch { errors[field.id] = 'Enter a valid URL' }
    }
    return errors
  }, {})
}

export function moveField(fields: FormField[], activeId: string, overId: string): FormField[] {
  const from = fields.findIndex((field) => field.id === activeId)
  const to = fields.findIndex((field) => field.id === overId)
  if (from < 0 || to < 0 || from === to) return fields
  const copy = [...fields]
  const [moved] = copy.splice(from, 1)
  if (moved) copy.splice(to, 0, moved)
  return copy
}
